import React from 'react';
import { MdLocationOn, MdPhone, MdAccessTime } from 'react-icons/md';
import { FaGoogle } from 'react-icons/fa';
import './Addresses.css';

const Addresses = () => {

    // Store Address
    const storeAddress = {
        name: 'Aditi Textile',
        address: 'Near SBI Khetrajpur branch, Khetrajpur ',
        city: 'Sambalpur',
        state: 'Odisha',
        pincode: '768003',
        phone: '9437737336',
        altPhone: '8917685615',
        hours: 'Open ⋅ Closes 8:30 pm',
        rating: '4.05',
        type: 'store',
        googleMapsLink: 'https://maps.app.goo.gl/Zdh21Sk33D5raDZp8'
    };

    return (
        <div className="addresses-page">
            <div className="page-header">
                <h1>My Addresses</h1>
            </div>

            {/* Store Address Section */}
            <div className="store-section">
                <h2 className="section-title">Visit Our Store</h2>
                <div className="store-card">
                    <div className="store-header">
                        <div>
                            <h3>{storeAddress.name}</h3>
                            <div className="store-rating">
                                <FaGoogle size={16} color="#4285F4" />
                                <span>{storeAddress.rating} Google reviews</span>
                            </div>
                            <p className="store-type">Women's SAMBALPURI clothing store in Sambalpur, Odisha</p>
                        </div>
                    </div>

                    <div className="store-details">
                        <div className="store-detail-item">
                            <MdLocationOn size={20} color="#e63946" />
                            <div>
                                <strong>Address</strong>
                                <p>{storeAddress.address}</p>
                                <p>{storeAddress.city}, {storeAddress.state} {storeAddress.pincode}</p>
                            </div>
                        </div>

                        <div className="store-detail-item">
                            <MdPhone size={20} color="#e63946" />
                            <div>
                                <strong>Phone</strong>
                                <p>
                                    <a href={`tel:${storeAddress.phone}`}>{storeAddress.phone}</a>
                                    {' / '}
                                    <a href={`tel:${storeAddress.altPhone}`}>{storeAddress.altPhone}</a>
                                </p>
                            </div>
                        </div>

                        <div className="store-detail-item">
                            <MdAccessTime size={20} color="#e63946" />
                            <div>
                                <strong>Hours</strong>
                                <p>{storeAddress.hours}</p>
                            </div>
                        </div>
                    </div>

                    <div className="store-actions">
                        <a 
                            href={storeAddress.googleMapsLink} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="directions-btn"
                        >
                            <MdLocationOn size={20} />
                            Get Directions
                        </a>
                        <a 
                            href={`tel:${storeAddress.phone}`}
                            className="call-btn"
                        >
                            <MdPhone size={20} />
                            Call Now
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Addresses;
